import React, { useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import HeroSection from './HeroSection';
import NavigationTabs from './NavigationTabs';
import FAQSection from './FAQSection';
import GuidesSection from './GuidesSection';
import HelpCTA from './HelpCTA';


const InvestorCenter = () => {
    const [activeTab, setActiveTab] = useState('faq');
    return (
        <>
            <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow">
                <HeroSection />
                <NavigationTabs activeTab={activeTab} setActiveTab={setActiveTab} />

                {activeTab === 'faq' && <FAQSection />}
                {activeTab === 'guides' && <GuidesSection />}
                <HelpCTA />
            </main>
            <Footer />
        </div>
        </>
    );
};

export default InvestorCenter;